export default __webpack_public_path__ + "static/img_cash_24_7.png";